if (!customElements.get('smileyrush-sticky-cart')) {
  customElements.define('smileyrush-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.sectionId = this.dataset.sectionId;
      this.primaryButton = document.getElementById('ProductSubmitButton-' + this.sectionId);
      this.select = this.querySelector('[data-sr-sticky-select]');
      this.variantInput = this.querySelector('[data-sr-sticky-variant]');
      this.submit = this.querySelector('[data-sr-sticky-submit]');
      this.price = this.querySelector('[data-sr-sticky-price]');
      this.compare = this.querySelector('[data-sr-sticky-compare]');
      this.save = this.querySelector('[data-sr-sticky-save]');
      this.saveValue = this.querySelector('[data-sr-sticky-save-value]');
      this.image = this.querySelector('.sr-sticky-cart__image');
      try {
        this.variants = JSON.parse(this.querySelector('[data-sr-sticky-variants]')?.textContent || '[]');
      } catch {
        this.variants = [];
      }

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };

      this.select?.addEventListener('change', () => this.setVariant(this.select.value), options);
      window.addEventListener('scroll', () => this.updateVisibility(), { ...options, passive: true });
      window.addEventListener('resize', () => this.updateVisibility(), { ...options, passive: true });
      document.addEventListener('change', (event) => {
        if (event.target === this.select) return;
        window.requestAnimationFrame(() => this.syncFromMain());
      }, options);

      this.syncFromMain();
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.initialized = false;
    }

    money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD'
        }).format((Number(cents) || 0) / 100);
      } catch {
        return '$' + ((Number(cents) || 0) / 100).toFixed(2);
      }
    }

    setVariant(id) {
      const variant = this.variants.find((item) => String(item.id) === String(id));
      if (!variant) return;

      if (this.variantInput) this.variantInput.value = variant.id;
      if (this.select && this.select.value !== String(variant.id)) this.select.value = String(variant.id);
      if (this.submit) this.submit.disabled = !variant.available;
      if (this.price) this.price.textContent = this.money(variant.price);

      const compare = Number(variant.compare_at_price) || 0;
      const price = Number(variant.price) || 0;
      if (this.compare) {
        this.compare.hidden = !(compare > price);
        this.compare.textContent = compare > price ? this.money(compare) : '';
      }
      const saving = compare > price ? Math.round((compare - price) * 100 / compare) : 0;
      if (this.save) this.save.hidden = saving <= 0;
      if (this.saveValue) this.saveValue.textContent = String(saving);
      if (this.image && variant.image) this.image.src = variant.image;
    }

    syncFromMain() {
      const mainInput = document.querySelector('#ProductInfo-' + this.sectionId + ' .product-variant-id');
      if (mainInput?.value) this.setVariant(mainInput.value);
    }

    updateVisibility() {
      if (!this.primaryButton) {
        const visible = window.scrollY > 500;
        this.dataset.visible = String(visible);
        this.setAttribute('aria-hidden', String(!visible));
        return;
      }
      const rect = this.primaryButton.getBoundingClientRect();
      const visible = rect.bottom < 0;
      this.dataset.visible = String(visible);
      this.setAttribute('aria-hidden', String(!visible));
    }
  });
}
